import { useI18n } from '../i18n/config'

export function useLocale() {
  const { locale, setLocale, t, get } = useI18n()
  return { locale, setLocale, t, get }
}
